export default __webpack_public_path__ + "static/media/bathtub.c58dd869.svg";